import { render, staticRenderFns } from "./FacilityView.vue?vue&type=template&id=b4f5b8ce&scoped=true&"
import script from "./FacilityView.vue?vue&type=script&lang=js&"
export * from "./FacilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f5b8ce",
  null
  
)

export default component.exports